import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next"; // NEW
import WhyChooseUs from "../sections/whyChoouseUs";
import Header from "../config/header";
import useInView from "../hooks/useInView";
import Footer from "../config/footer";
import PartnersCarousel from "../sections/partners";
import OurSolutions from "../sections/solutions";
import Timeline from "../sections/timeline";
import StoryScroll from "../sections/ourStory";
import ShowcaseCarousel from "../sections/medias";
import ThreeDScene from "../sections/3d";
import { motion } from "framer-motion";
import { Truck } from "lucide-react";
import HeaderHome from "../config/header copy";
import StatsCounter from "../sections/statsCounter";
import { Helmet } from "react-helmet-async";
import HolidayGreetingBanner from "../sections/banner";
import VideoSection from "../sections/videosection";
import OurStoryHome from "../sections/story";
import HeroCarousel from "../sections/hercarousel";
import TimelineforAbout from "../sections/timelineforbout";
import JourneyConcepts from "../sections/ourStoryv2";
import OurSolutionsv2 from "../sections/solutionsv2";
import HeaderHomeV3 from "../config/header-revamp copy";
import HeaderHomeV2 from "../config/header-revamp";

const WebsiteMain = () => {
  const { t } = useTranslation(); // NEW

  const [storyRef, storyVisible] = useInView();
  const [featuresRef, featuresVisible] = useInView();
  const [missionRef, missionVisible] = useInView();
  const [whyRef, whyVisible] = useInView();
  const [partnersRef, partnersVisible] = useInView();
  const [solutionRef, solutionVisible] = useInView();
  const [timelineRef, timelineVisible] = useInView();
  const [statsRef, statsVisible] = useInView();
  // Add this hook at the top of your component (inside WebsiteMain, before return):
  const [currentSlide, setCurrentSlide] = useState(0);

  // Add these carousel images (replace with your real images):
  const heroSlides = [
    {
      src: "https://scontent.fmnl3-4.fna.fbcdn.net/v/t39.30808-6/305844029_447582417394066_7425055348128986817_n.png?_nc_cat=101&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=qqqVrQ7cblAQ7kNvwFLZh9N&_nc_oc=AdpSa1dqQQzg6K3FHFS3IUQ86i102m8WdAybkqJnP-JN3-uZ5BsCjQs5WpFWBuyRlhSwMVhhB27I2gU9yT-JrJ27&_nc_zt=23&_nc_ht=scontent.fmnl3-4.fna&_nc_gid=KIRMTq-gF5hy3LNK7Gtu4w&_nc_ss=7b289&oh=00_Af5ZKPQY5O6RzKJOwKxkEhFj6kQct_2y5PnKykrDbsba8w&oe=6A11B618",
      alt: "Prime Sales Warehouse",
    },
    {
      src: "https://www.elementlogic.net/content/uploads/sites/8/2024/10/for-4-main-functions-of-warehouse-1200x649-1.jpg", // replace with your real image
      alt: "Cold Chain Solutions",
    },
    {
      src: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTiFRpChdkfgm2TPi1WwvhoeKPIgYSPnU8TfA&s", // replace with your real image
      alt: "Forklift Operations",
    },
  ];

  // Add auto-advance effect (place with your other useEffects):
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);
  const [dark, setDark] = useState(() => {
    if (typeof window !== "undefined") {
      return localStorage.getItem("darkMode") === "true";
    }
    return false;
  });

  useEffect(() => {
    localStorage.setItem("darkMode", dark);
    if (dark) document.documentElement.classList.add("dark");
    else document.documentElement.classList.remove("dark");
  }, [dark]);

  return (
    <div className="bg-background-light  dark:bg-background-dark font-display text-gray-800 dark:text-gray-200 min-h-screen flex flex-col">
      {/* <HeaderHome dark={dark} setDark={setDark} /> */}
      <HeaderHomeV3 />
      {/* <HeaderHomeV2 /> */}

      <Helmet>
        <title>{t("meta_title")}</title>
        <meta name="description" content={t("meta_description")} />
        <meta
          name="keywords"
          content="racking system Philippines, industrial storage solutions, pallet racks, warehouse shelves, forklifts Philippines, cold chain systems, Prime Sales Inc, Prime Group"
        />
        <link rel="canonical" href="https://www.primegroup.com.ph/" />
      </Helmet>
      <main className="flex-1 py- ">
        {/* Hero Section */}
        <div className="relative w-full h-screen overflow-hidden">
          <video
            src="/bg9.mp4"
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          />

          <div className="absolute inset-0 bg-black/50 z-[1]" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent z-[2]" />

          <div className="absolute inset-0 z-10 flex items-center justify-center text-center px-4 pb-10">
            <div className="max-w-4xl">
              <div className="text-xs font-bold tracking-[0.25em] uppercase mb-3 text-[#75C043]">
                {t("hero_eyebrow")}
              </div>

              <h1 className="text-xl md:text-5xl font-bold mb-4 leading-tight text-white">
                {t("hero_title")}
              </h1>

              <p className="text-xs md:text-base font-light leading-relaxed max-w-3xl mx-auto text-gray-200">
                {t("hero_desc")}
              </p>

              <div className="mt-6">
                <a
                  href="/contact"
                  className="inline-flex items-center gap-2 md:px-7 md:py-3 px-4 py-2 rounded-full text-xs md:text-sm font-semibold tracking-wide uppercase transition-all duration-300 hover:scale-105 active:scale-95"
                  style={{
                    background: "#75C043",
                    color: "#000",
                    boxShadow: "0 0 24px #75C04355",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = "0 0 36px #75C04388";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = "0 0 24px #75C04355";
                  }}
                >
                  {t("hero_cta")}
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M5 12h14M12 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* <HeroCarousel dark={dark} /> */}
        {/* OUR STORY */}
        <div className="px-4 py-0 sm:px-6 sm:py-0 lg:px-8 transition-all duration-700 ease-out ">
          <section className="text-center py-0">
            <div className="mt-0  md:mt-8 grid gap-6 sm:grid-cols-2 xl:px-4  2xl:px-16">
              {[
                {
                  title: t("mission_title"),
                  desc: t("mission_desc"),
                },
                {
                  title: t("vision_title"),
                  desc: t("vision_desc"),
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className="p-6 rounded-lg border border-primary/20 dark:border-primary/30 bg-background-light dark:bg-background-dark"
                >
                  <h3 className="text-xl font-semibold text-green-500 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base flex-col flex text-gray-600 dark:text-gray-300">
                    {item.desc}

                    <span>{item.subdesc}</span>
                  </p>
                </div>
              ))}
            </div>
          </section>
          <OurStoryHome />

          {/* Features */}
          <section className=" text-center xl:px-4  2xl:px-16">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white">
              {t("who_title_1")}{" "}
              <span className="text-[#75C043]"> {t("who_title_2")}</span>
            </h2>

            <p className="mt-4 text-sm md:text-base max-w-4xl mx-auto text-gray-600 dark:text-gray-300">
              {t("who_desc")}
            </p>

            <div
              ref={featuresRef}
              className={`mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 transform transition-all duration-700 ease-out ${
                featuresVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-10"
              }`}
            >
              {[
                {
                  title: t("feature_1_title"),
                  desc: t("feature_1_desc"),
                },
                {
                  title: t("feature_2_title"),
                  desc: t("feature_2_desc"),
                },
                {
                  title: t("feature_3_title"),
                  desc: t("feature_3_desc"),
                },
                {
                  title: t("feature_4_title"),
                  desc: t("feature_4_desc"),
                },
              ].map((feature, i) => (
                <div
                  key={i}
                  className="flex flex-col gap-3 rounded-lg border border-primary/20 dark:border-primary/30 bg-background-light dark:bg-background-dark p-6 shadow-sm"
                >
                  <div className="h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary">
                    <span className="text-xl font-bold">#{i + 1}</span>
                  </div>
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                    {feature.title}
                  </h3>
                  <p className="text-sm md:text-base text-gray-600 dark:text-gray-300">
                    {feature.desc}
                  </p>
                </div>
              ))}
            </div>
          </section>

          <div
            ref={solutionRef}
            className={`transition-all duration-700 ease-out mt-8 ${
              solutionVisible
                ? "opacity-100 translate-y-0 animate-fadeInUp"
                : "opacity-0 translate-y-10"
            }`}
          >
            <OurSolutionsv2 />
          </div>
          <div
            ref={whyRef}
            className={`transition-all duration-700 ease-out ${
              whyVisible
                ? "opacity-100 translate-y-0 animate-fadeInUp"
                : "opacity-0 translate-y-10"
            }`}
          >
            <WhyChooseUs />
          </div>
          {/* Add 3D Scene Section */}
          <JourneyConcepts dark={dark} />

          <div
            ref={timelineRef}
            className={`transition-all duration-700 ease-out  ${
              timelineVisible
                ? "opacity-100 translate-y-0 animate-fadeInUp"
                : "opacity-0 translate-y-10"
            }`}
          >
            <TimelineforAbout dark={dark} />
          </div>

          <div
            ref={partnersRef}
            className={`transition-all duration-700 ease-out ${
              partnersVisible
                ? "opacity-100 translate-y-0 animate-fadeInUp"
                : "opacity-0 translate-y-10"
            }`}
          >
            <ShowcaseCarousel />
            <div ref={statsRef}>
              <StatsCounter visible={statsVisible} />
            </div>
            <PartnersCarousel />
          </div>
        </div>

        {/* <HolidayGreetingBanner /> */}

        <VideoSection />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default WebsiteMain;
